import { capitalizeFirstLetter } from '@/core/lib/utils/capitalize-first-letter'
import { RemoteImage } from '@/core/ui/atoms/remote-image'
import { PostModel } from '@/features/blog/types/models/post.model'
import { Link } from '@/i18n/navigation'
import React from 'react'

export const Post: React.FC<PostModel & { className?: string }> = ({
  brief,
  cover,
  name,
  slug,
  className = '',
}) => {
  return (
    <Link href={`/blog/post/${slug}`} prefetch={false}>
      <div
        className={`mb-4 flex h-full w-full flex-col items-start gap-2 rounded-md pe-3 ${className}`}
      >
        <RemoteImage
          height={208}
          width={208}
          alt=''
          src={cover.url}
          className='border-grey-10 h-52 w-full rounded-md border-4 object-cover'
        />
        <h6 className='text-red text-2xl leading-6 font-medium'>
          {capitalizeFirstLetter(name)}
        </h6>
        <p className='text-navy line-clamp-3 overflow-hidden text-base font-medium text-ellipsis'>
          {capitalizeFirstLetter(brief)}
        </p>
      </div>
    </Link>
  )
}
